import { BaseConnector } from './baseConnector';

class InvitationSourceConnector extends BaseConnector {
  getInvitationSources() {
    var url = `${this.baseApiUrl}/invitationSource`;
    return this.authFetch(url);
  }
}

export { InvitationSourceConnector };
